module.exports = __webpack_public_path__ + "static/media/glotio_icon.e24e5097.svg";